/* Copyright (c) 2026. Amazon.com, Inc. or its affiliates. All rights reserved. */

import type { Unsubscribe } from '@amazon/vinyl-util'
import { installLazily } from '@/core/installLazily'
import { ctx } from '@/util/context'

const { errorHandler } = ctx('explicitLanguageFilterSync')

/** {@link installExplicitLanguageFilterSync}, whose gql and user-context helpers load off the boot chunk. */
export function installExplicitLanguageFilterSyncLazy(): Unsubscribe {
    return installLazily(
        import('@/explicitLanguageFilter/explicitLanguageFilterSync'),
        (m) => m.installExplicitLanguageFilterSync(),
        errorHandler
    )
}
